import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  AutoForecastSettingDetailApi,
  FindOptions,
  UpdateAutoForecastSettingDetailBody,
  UpdateMultiAutoForecastSettingDetailBody,
} from 'api';

export const findAutoForecastSettingDetailWithEntity = createAsyncThunk(
  'autoForecastSettingDetail/findAutoForecastSettingDetailWithEntity',
  async (option: FindOptions, { rejectWithValue }) => {
    try {
      const response = await AutoForecastSettingDetailApi.findWithEntity(
        option
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAutoForecastSettingDetail = createAsyncThunk(
  'autoForecastSettingDetail/updateAutoForecastSettingDetail',
  async (
    params: { id: string; body: UpdateAutoForecastSettingDetailBody },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await AutoForecastSettingDetailApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiAutoForecastSettingDetail = createAsyncThunk(
  'autoForecastSettingDetail/updateMultiAutoForecastSettingDetail',
  async (
    body: UpdateMultiAutoForecastSettingDetailBody,
    { rejectWithValue }
  ) => {
    try {
      const response = await AutoForecastSettingDetailApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface InitialState {
  data: any | undefined;
}

const initialState: InitialState = {
  data: undefined,
};

const autoForecastSettingDetailSlice = createSlice({
  name: 'autoForecastSettingDetail',
  initialState,
  reducers: {},
});

const { reducer: AutoForecastSettingDetailReducer } =
  autoForecastSettingDetailSlice;

export default AutoForecastSettingDetailReducer;
